import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui';
import AMap from './plugins/Amap.js'
import './api/axios'
import 'element-ui/lib/theme-chalk/index.css';

// ElementUI.Select.computed.readonly = function () {
  //   const isIE = !this.$isServer && !Number.isNaN(Number(document.documentMode));
  //   return !(this.filterable || this.multiple || !isIE) && !this.visible;
  // };
  
Vue.use(AMap)
Vue.use(ElementUI);
Vue.config.productionTip = false
Vue.directive('title', {
  inserted: function (el, binding) {
    document.title = el.dataset.title
  }
})

new Vue({
  router,
  mode: 'hash',
  render: h => h(App),
}).$mount('#app')